import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect as RouterRedirect } from 'react-router-dom';

const Redirect = ({
    status, withQuery, from, to, exact,
}) => {

    return (
        <Route
            render={({ staticContext, location }) => {

                if (staticContext && status) staticContext.status = status;
                if (withQuery && location.search) to = `${to}${location.search}`;
                return <RouterRedirect exact={exact} from={from} to={to} />;

            }}
        />
    );

};

Redirect.propTypes = {
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    exact: PropTypes.bool,
    status: PropTypes.number,
    withQuery: PropTypes.bool,
};

export default Redirect;
